import { render } from "./CompleteDetails.vue?vue&type=template&id=ebc1030a"
import script from "./CompleteDetails.vue?vue&type=script&lang=js"
export * from "./CompleteDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__